<template>
  <div class="app-container">
    <template v-if="$store.state.auth.canRenderDefaultLayout">
      <div class="content-container" style="width: 100%;margin-left: 0;" v-if="result?.ismenu=='1'">
        <div class="container-n">
          <div id="app-page" class="app-page">
            <top-alert />
            <slot />
          </div>
        </div>
      </div>
      <template v-else>
        <navbar />
        <div class="app-content position-relative h-100">
          <sidebar-drawer v-if="isShowMenu" :active-menu="l2Menu" />
          <l2-menu :l2-menu="l2Menu" v-if="l2MenuVisible && isShowMenu" />
          <div class="content-container" :class="{ 'l2-menu-show': l2MenuVisible && l2MenuVisibleForStore }">
            <div class="container-n">
              <div id="app-page" class="app-page">
                <top-alert />
                <slot />
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="h-100 d-flex align-items-center justify-content-center">
        <a-spin />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '@scope/layouts/Navbar'
// import TopAlert from '@/sections/TopAlert'
import { menusConfig } from '@/router/routes'
import L2Menu from '../Sidebar/Menu'
import SidebarDrawer from '../Sidebar/Drawer'

export default {
  name: 'DefaultLayout',
  components: {
    SidebarDrawer,
    Navbar,
    // TopAlert,
    'l2-menu': L2Menu,
  },
  data () {
    return {
      l2MenuVisible: true,
      l2Menu: {},
      menuitems: menusConfig,
      result: {},
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isShowMenu () {
      const { globalSetting } = this.$store.state
      if (!globalSetting || (globalSetting && !globalSetting.value) || (globalSetting.value && !globalSetting.value.key)) {
        return true
      }
      return globalSetting.value.key.length > 0
    },
    l2MenuVisibleForStore () {
      return this.$store.state.setting.l2MenuVisible
    },
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        const newParentPath = val.matched[0] && val.matched[0].path
        const oldParentPath = oldVal && oldVal.matched && oldVal.matched[0] && oldVal.matched[0].path
        if (newParentPath !== oldParentPath) {
          const firstMatched = val.matched[0]
          for (let i = 0, len = this.menuitems.length; i < len; i++) {
            const item = this.menuitems[i]
            if (item.meta.group === firstMatched.meta.group) {
              this.l2Menu = item
              // let l2MenuVisible = false
              // if (item.menus) {
              //   l2MenuVisible = true
              // }
              // this.l2MenuVisible = l2MenuVisible
              break
            } else {
              this.l2Menu = {}
              // this.l2MenuVisible = false
            }
          }
        }
      },
      immediate: true,
    },
  },
  mounted () {
    const urlStr = window.location.href.split('?')[1]
    const urlSearchParams = new URLSearchParams(urlStr)
    this.result = Object.fromEntries(urlSearchParams.entries())
    if (this.result?.ismenu === '1') {
      this.l2MenuVisible = false
      this.$store.commit('setting/SET_L2_MENU_VISIBLE', false)
    }
  },
}
</script>

<style lang="less" scoped>
.app-content {
  padding-top: 56px;
}
.app-page {
  margin-bottom: 74px;
  padding: 15px;
  &.l2-menu-show {
    margin-left: 208px !important;
  }
}
.content-container{
  background-color: #ebedf2;
  padding: 15px;
  margin-left: 208px;
  width: calc(100% - 208px);
  height: 100%;
  display: flex;
  .container-n{
    flex: 1;
    box-shadow: rgba(0, 7, 101, 0.15) 0px 1px 4px;
    background-color: rgb(255, 255, 255);
    border-radius: 6px;
    overflow: auto;
  }
}
</style>
